<template>
  <el-container class="chat-process">
    <el-header class="header-style">
      <el-divider content-position="left">沟通过程列表</el-divider>
      <el-collapse accordion v-model="activeOpen">
        <el-collapse-item>
          <template slot="title">高级筛选</template>
          <el-row :span="24" style="display: flex; align-items: center">
            <el-col :span="2">反馈时间</el-col>
            <el-col :span="6">
              <el-date-picker
                size="mini"
                v-model="searchArr.chat_time"
                type="datetimerange"
                :picker-options="contactPicker"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
              >
              </el-date-picker>
            </el-col>
            <el-col :span="2" :offset="4">选择角色</el-col>
            <el-col :span="4">
              <el-select v-model="searchArr.role_id" placeholder="请选择角色" size="mini">
                <el-option
                  v-for="(item, index) in roles"
                  :key="index"
                  :label="item.role_name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2" :offset="2">反馈人员</el-col>
            <el-col :span="4">
              <el-cascader
                  style="width: 100%;"
                  v-model="searchArr.executor"
                  placeholder="请选择反馈人员"
                  :options="personnel"
                  size="mini"
                  :props="{ expandTrigger: 'hover' }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                  >
                </el-cascader>
            </el-col>
          </el-row>
          <el-row
            :span="24"
            style="display: flex; align-items: center; margin-top: 0.2rem"
          >
            <el-col :span="2">联系方式</el-col>
            <el-col :span="4">
              <el-select
                v-model="searchArr.contact_type"
                filterable
                placeholder="请选择"
                clearable
                size="mini"
              >
                <el-option
                  v-for="option in chat_types"
                  :key="option.id"
                  :label="option.process_check_name"
                  :value="option.id"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">过程类型</el-col>
            <el-col :span="4">
              <el-select
                v-model="searchArr.process_type"
                filterable
                placeholder="请选择"
                clearable
                size="mini"
              >
                <el-option
                  v-for="option in process_types"
                  :key="option.id"
                  :label="option.process_check_name"
                  :value="option.id"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2" :offset="1">沟通提醒</el-col>
            <el-col :span="3">
              <el-radio-group v-model="searchArr.is_notice" size="mini">
                <el-radio-button label="1">需要</el-radio-button>
                <el-radio-button label="0">不需要</el-radio-button>
              </el-radio-group>
            </el-col>
            <el-col :span="2" :offset="1">客户意向</el-col>
            <el-col :span="3">
              <el-select
                v-model="searchArr.intention"
                placeholder="请选择"
                size="mini"
                clearable
              >
                <el-option :value="1" label="A"></el-option>
                <el-option :value="2" label="B"></el-option>
                <el-option :value="3" label="C"></el-option>
                <el-option :value="4" label="D"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row style="text-align: center; margin-top: 0.4rem">
            <el-col>
              <el-button type="primary" size="mini" @click="handleASearSub"
                >查询</el-button
              >
              <el-button type="danger" size="mini" @click="handleASearClear"
                >清除</el-button
              >
            </el-col>
          </el-row>
        </el-collapse-item>
      </el-collapse>
    </el-header>

    <el-main class="main-style">
      <el-table
      height="calc(100vh - 276px)"
        :data="reflects"
        style="width: 100%"
        border
        size="medium"
        :header-cell-style="{
          background: '#ecf4ff',
          color: '#333',
          fontWeight: '900',
          fontSize: '0.28rem',
        }"
      >
        <el-table-column label="沟通时间" width="140">
          <template slot-scope="scope">
            <!-- <span>{{ scope.row.created_at }}</span> -->
            <date-formatter :date-value="scope.row.created_at"></date-formatter>
          </template>
        </el-table-column>
        <el-table-column label="反馈人员" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.executor }}</span>
          </template>
        </el-table-column>
        <el-table-column label="过程类型" width="200">
          <template slot-scope="scope">
            {{ scope.row.check_type ? scope.row.check_type.title : "" }}
          </template>
        </el-table-column>
        <el-table-column label="联系方式">
          <template slot-scope="scope">
            {{ scope.row.contact_type }}
          </template>
        </el-table-column>
        <el-table-column label="沟通关键词" width="200">
          <template slot-scope="scope">
            {{ scope.row.keyword }}
          </template>
        </el-table-column>
        <el-table-column label="沟通内容" width="100">
          <template slot-scope="scope">
            <el-link type="primary" @click="handleReflectInfo(scope.row.id)">{{
              scope.row.reflect_content
            }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="客户意向" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.satisfy === 1">A</span>
            <span v-else-if="scope.row.satisfy === 2">B</span>
            <span v-else-if="scope.row.satisfy === 3">C</span>
            <span v-else>D</span>
          </template>
        </el-table-column>
        <el-table-column label="是否联系上" width="150">
          <template slot-scope="scope">
            {{ scope.row.is_contacted === 1 ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column label="是否提醒" width="120">
          <template slot-scope="scope">
            {{ scope.row.is_notice === 1 ? "需要" : "不需要" }}
          </template>
        </el-table-column>
      </el-table>
    </el-main>

    <el-footer class="footer-style">
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :hide-on-single-page="false"
        :current-page="npage"
        layout="sizes, total, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="checkInPerPage"
        background
      >
      </el-pagination>
    </el-footer>

    <!-- 沟通记录 -->
    <el-drawer
      title="相关沟通记录"
      :visible.sync="developAdviceDrawer"
      direction="rtl"
      size="50%"
    >
      <div class="m-tabs-content">
        <el-row>
          <el-timeline>
            <el-timeline-item
              v-for="reflect in reflectRecords"
              :key="reflect.id"
              :timestamp="reflect.created_at"
              placement="top"
            >
              <el-card>
                <h5 style="line-height: 0.4rem">
                  {{ reflect.executor }} 通过 {{ reflect.contact_type }} 进行联系，
                  <span v-if="reflect.contact_duration">
                    沟通了 {{ reflect.contact_duration }} 秒，</span
                  >
                  是否取得联系：<span v-if="reflect.is_contacted === 1">是，</span>
                  <span v-else-if="reflect.is_contacted === 2">否，</span>
                  <span>
                    客户意向：
                    <span v-if="reflect.satisfy === 1">A</span>
                    <span v-else-if="reflect.satisfy === 2">B</span>
                    <span v-else-if="reflect.satisfy === 3">C</span>
                    <span v-else-if="reflect.satisfy === 4">D</span>
                  </span>
                  ，沟通关键词：{{ reflect.keyword }}
                  <span v-if="reflect.is_notice === 1"
                    >需要提醒，提醒时间：{{ reflect.next_contact_time }}</span
                  >
                  <span v-else>，不需要提醒。</span>
                </h5>

                <p>反馈内容：{{ reflect.reflect_content }}</p>
                <ul
                  class="el-upload-list el-upload-list--picture"
                  style="margin-bottom: 0.2rem"
                >
                  <li
                    class="el-upload-list__item is-success"
                    v-for="image in reflect.images"
                    :key="image.id"
                  >
                    <img class="el-upload-list__item-thumbnail" :src="image.url" />
                    <a
                      class="el-upload-list__item-name"
                      @click="handleReflectPreview(image)"
                      >{{ image.name }}</a
                    >
                  </li>
                </ul>

                <!-- 回复内容 -->
                <el-divider content-position="left">开发建议记录</el-divider>
                <el-timeline>
                  <el-timeline-item
                    v-for="item in reflect.reflect_subs"
                    :key="item.id"
                    :timestamp="item.created_at"
                    placement="top"
                  >
                    <p>{{ item.replyer_name }}回复：{{ item.content }}</p>
                  </el-timeline-item>
                </el-timeline>

                <el-row v-if="developText === reflect.id">
                  <el-input
                    type="textarea"
                    placeholder="回复内容"
                    v-model="develop.content"
                  ></el-input>
                </el-row>
                <!-- 开发建议 -->
                <el-row class="mt-10 tr">
                  <el-button
                    v-if="developText === reflect.id"
                    type="warning"
                    size="mini"
                    @click="developAdviceCancel(reflect.id)"
                    >取消</el-button
                  >
                  <el-button
                    v-if="developText === reflect.id"
                    type="primary"
                    size="mini"
                    @click="developAdviceSave(reflect.id)"
                    >保存</el-button
                  >
                  <el-button
                    v-if="developText !== reflect.id"
                    type="primary"
                    size="mini"
                    @click="developAdvice(reflect.id)"
                    >开发建议</el-button
                  >
                </el-row>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </el-row>
      </div>
    </el-drawer>
  </el-container>
</template>

<script>
import DateFormatter from "common/DateFormatter";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';

export default {
  name: "ChatProcess",
  components: { DateFormatter },
  data() {
    return {
      activeOpen: "",
      contactPicker: {
        shortcuts: [
          {
            text: "今日",
            onClick: () => {
              const start = new Date();
              start.setHours(0, 0, 0);
              const end = new Date();
              end.setHours(23, 59, 59);
              this.searchArr.chat_time = [start, end];
            },
          },
          {
            text: "昨日",
            onClick: () => {
              const start = new Date();
              start.setDate(start.getDate() - 1);
              start.setHours(0, 0, 0);
              const end = new Date();
              end.setDate(end.getDate() - 1);
              end.setHours(23, 59, 59);
              this.searchArr.chat_time = [start, end];
            },
          },
          {
            text: "本周",
            onClick: () => {
              const currentDate = new Date();
              const start = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate() - currentDate.getDay()
              );
              start.setHours(0, 0, 0);
              const end = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate() - currentDate.getDay() + 6
              );
              end.setHours(23, 59, 59);
              this.searchArr.chat_time = [start, end];
            },
          },
          {
            text: "上周",
            onClick: () => {
              const currentDate = new Date();
              const start = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate() - currentDate.getDay() - 7
              );
              start.setHours(0, 0, 0);
              const end = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate() - currentDate.getDay() - 1
              );
              end.setHours(23, 59, 59);
              this.searchArr.chat_time = [start, end];
            },
          },
          {
            text: "本月",
            onClick: () => {
              const currentDate = new Date();
              const start = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                1
              );
              start.setHours(0, 0, 0);
              const end = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth() + 1,
                0
              );
              end.setHours(23, 59, 59);
              this.searchArr.chat_time = [start, end];
            },
          },
          {
            text: "上月",
            onClick: () => {
              const currentDate = new Date();
              const start = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth() - 1,
                1
              );
              start.setHours(0, 0, 0);
              const end = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
              end.setHours(23, 59, 59);
              this.searchArr.chat_time = [start, end];
            },
          },
        ],
      },
      searchArr: {
        chat_time: [],
        executor: "",
        contact_type: "",
        process_type: "",
        is_notice: null,
        role_id: "",
        intention: null,
      },
      npage: 1,
      checkInPerPage: 30,
      total: null,
      direction: "rtl",
      searchLoading: false,
      searchCheckSetting: [],
      reflects: [],
      personnel: [],
      chat_types: [],
      process_types: [],
      roles: [],
      developAdviceDrawer: false,
      reflectRecords: [],
      developText: null,
      develop: {
        reflect_id: null,
        content: "",
      },
    };
  },
  mounted() {
    this.loadTable();
    document.addEventListener('click', this.handleClickCollapseOutSide);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickCollapseOutSide);
  },
  computed: {
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    loadTable() {
      this.$axios
        .get("api/admin/tyc_order_reflect/get_reflects", {
          params: {
            page: this.npage,
            perpage: this.checkInPerPage,
            searchItem: this.searchArr,
          },
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.reflects = data.data.list.data;
            this.personnel = data.data.personnel;
            this.chat_types = data.data.chat_types;
            this.process_types = data.data.process_types;
            this.roles = data.data.roles;
            this.total = data.data.list.total;
          }
        })
        .catch();
    },
    handleClickCollapseOutSide(event) {
      const elCollapse = this.$el.querySelector('.el-collapse');
      if (elCollapse && !elCollapse.contains(event.target)) {
        this.activeOpen = '';
      }
    },
    handleReflectInfo(id) {
      this.reflectRecords = [];
      this.developAdviceDrawer = true;
      setTimeout(() => {
        this.$axios
          .post("api/admin/tyc_order_reflect/get_reflect_info", { id: id })
          .then(({ data }) => {
            if (data.code === 0) {
              this.reflectRecords = data.data.reflectRecords;
            }
          });
      }, 100);
    },
    developAdvice(id) {
      this.developText = id;
    },
    developAdviceCancel(id) {
      this.develop.reflect_id = null;
      this.develop.content = "";
      this.developText = null;
    },
    developAdviceSave(reflectId) {
      if (!this.develop.content) {
        this.$message.error("请填写开发建议！");
        return;
      }
      this.develop.reflect_id = reflectId;
      this.$axios
        .post("/api/admin/tyc_order_reflect/store", { develop: this.develop })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.$message.success("提交成功！");
            this.clearReflect();
            this.handleReflectInfo(reflectId);
          }
        });
    },
    handleReflectPreview(file) {
      let tempwindow = window.open("_blank");
      tempwindow.location = file.url;
    },
    clearReflect() {
      this.developText = null;
      this.develop.content = "";
      this.develop.reflect_id = null;
    },
    handleCurrentChange(val) {
      this.npage = val;
      this.loadTable();
    },
    handleSizeChange(val) {
      this.checkInPerPage = val;
      this.loadTable();
    },
    handleASearSub() {
      this.npage = 1;
      this.activeOpen = '';
      this.loadTable();
    },
    handleASearClear() {
      this.searchArr.chat_time = [];
      this.activeOpen = '';
      (this.searchArr.executor = ""),
        (this.searchArr.contact_type = ""),
        (this.searchArr.process_type = ""),
        (this.searchArr.is_notice = null);
      this.loadTable();
    },
    filterOptions(node, keyword) {
  return filterKeywordOptions(node, keyword);
}
  },
};
</script>

<style scoped>
.chat-process {
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
  max-height: 100vh;
  .header-style {
    z-index: 2;
    height: 98px !important;
    padding: 0px !important;
  }
  .main-style {
    z-index: 1;
    padding: 0px !important;
    overflow-y: auto;
  }
  .footer-style {
    text-align: right;
    .el-pagination {
      padding-top: 20px;
    }
  }
}

.m-tabs-content {
  padding: 0 0.2rem 0 0.4rem;

  .m-label {
    line-height: 0.64rem;
  }

  .el-row {
    margin-bottom: 0.4rem;
  }

  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }

  .tabs-title {
    color: #409eff;
  }
}

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.mt-10 {
  margin-top: 0.2rem;
}

.tr {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/data_analysis/ChatProcess.vue